import AAFShakaPlayer from '../all/shakaPlayer/AAFShakaPlayer';

class ArrisPlayer extends AAFShakaPlayer {
  constructor() {
    super();
  }
}

export default ArrisPlayer;


// WEBPACK FOOTER //
// ./src/devices/arris/Player.js